module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "vh1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SONG OF THE ROAD")])]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("The dust took my land and nothing grew")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("I took off with my brood. Was all I could do.")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("On Route 66, some folks was kind.")]), _c('p', {
    staticClass: "vtx3"
  }, [_vm._v("Andy Connors is one who comes to my mind.")]), _c('p', {
    staticClass: "vtx1"
  }, [_vm._v("At his garage he gassed up my heap,")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("Gave me 'n my family somewheres to sleep.")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("Then that rabid skunk give him such a bite!")]), _c('p', {
    staticClass: "vtx3"
  }, [_vm._v("He needed them shots that could fix him up right.")]), _c('p', {
    staticClass: "vtx1"
  }, [_vm._v("A stranger drove in and took him to get 'em,")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("Then took over the place. Guess Andy let him.")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("Stranger tended the store, daughters and farm")]), _c('p', {
    staticClass: "vtx3"
  }, [_vm._v("And the woman who lived there; kept 'em from harm.")]), _c('p', {
    staticClass: "vtx1"
  }, [_vm._v("Quite a story begun there, something to tell.")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("You can read all about it if you set fer a spell.")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("Me—I'm off in the mornin', me and my kin,")]), _c('p', {
    staticClass: "vtx3"
  }, [_vm._v("On Route 66 where big dreams begin.")]), _c('p', {
    staticClass: "vtx1"
  }, [_vm._v("Mother Road, take me west.")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("Lead the way to where the chances are best.")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("Rough or smooth, paved or gravel,")]), _c('p', {
    staticClass: "vtx"
  }, [_vm._v("You're the pathway to hope that I'm aimin' to travel.")]), _c('p', {
    staticClass: "eps1"
  }, [_vm._v("—F.S.I")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abe57bba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MotherRoad_epig-1.vue
// module id = 75
// module chunks = 0